import './Dialog.css'
import {
  Dialog as HeadlessDialog,
  DialogPanel,
  Transition,
  TransitionChild
} from '@headlessui/react'

export function Dialog({
  isOpen,
  close,
  children,
  onAfterLeave,
  fullscreen = false,
  preventCloseOnOutsideClick = false
}: {
  isOpen: boolean
  close: () => void
  children: React.ReactNode
  onAfterLeave?: () => void
  fullscreen?: boolean
  preventCloseOnOutsideClick?: boolean
}) {
  return (
    <Transition show={isOpen}>
      <HeadlessDialog
        onClose={preventCloseOnOutsideClick ? () => {} : close}
        className="dialog-container"
      >
        <TransitionChild
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className={fullscreen ? 'dialog-backdrop-fullscreen' : 'dialog-backdrop'} />
        </TransitionChild>

        <TransitionChild
          afterLeave={onAfterLeave}
          enter="ease-out duration-300"
          enterFrom="opacity-0 scale-95"
          enterTo="opacity-100 scale-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100 scale-100"
          leaveTo="opacity-0 scale-95"
        >
          <div className="dialog-wrapper">
            <DialogPanel
              className="dialog-panel"
              onKeyDown={
                preventCloseOnOutsideClick
                  ? event => {
                      if (event.key === 'Escape') {close()}
                    }
                  : undefined
              }
            >
              {children}
            </DialogPanel>
          </div>
        </TransitionChild>
      </HeadlessDialog>
    </Transition>
  )
}
